module.exports = "<svg style=\"height: 256px; width: 256px;\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M0 0h512v512H0z\" fill=\"transparent\" fill-opacity=\"0\"></path><g class style=\"touch-action: none;\" transform=\"translate(0,0)\"><path d=\"M256 29.816l-231 154v106.368l231-154 231 154V183.816zm0 128.043L105 259.783v90.283l151-101.925 151 101.925v-90.283zm0 112l-87 58.725v67.6l87-58 87 58v-67.6zm0 89.957l-87 58v64.368l87-58 87 58v-64.368z\" fill=\"currentColor\" fill-opacity=\"1\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/upgrade.svg
// module id = iBYP
// module chunks = 1